import script from "./NiceValue.vue?vue&type=script&setup=true&lang=js"
export * from "./NiceValue.vue?vue&type=script&setup=true&lang=js"

import "./NiceValue.vue?vue&type=style&index=0&id=38cb365b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cb365b"]])

export default __exports__